import React from 'react';
import styles from './Footer.module.css';
import { Link } from 'react-router-dom';

const Footer = () => {
    const handlePrivacySettingsClick = (e) => {
        e.preventDefault();
        if (window.UC_UI) {
            window.UC_UI.showSecondLayer();
        }
    };

    return (
        <footer className={styles['footer-container']}>
            <div className={styles['footer-links']}>
                <div className={styles['left-links']}>
                    <Link to="/termsandconditions">Terms and Conditions</Link>
                    <Link to="/contactus">Contact Us</Link>
                    <Link to="/PrivacyPolicy">Privacy Policy</Link>
                    <a
                        href="#"
                        onClick={handlePrivacySettingsClick}
                        style={{ whiteSpace: 'nowrap' }}
                    >
                        Privacy Settings
                    </a>
                </div>
                <div className={styles['right-link']}>
                    Copyright © 2023 Rocket Software Ltd
                </div>
            </div>
        </footer>
    );
};

export default Footer;
